import { useTranslation } from "react-i18next";
import { LiteBox } from "../../../../components/lite/LiteBox";
import useOrganizationStyles from "../use-organization-styles";
import { Typography } from "@material-ui/core";
import { GetOrganizationDomainsWithCountersQuery } from "../types/queries.generated";

interface IUserTableProps {
	users: GetOrganizationDomainsWithCountersQuery["GetOrganizationDomainsWithCounters"]["domains"][0]["users"];
}

export const UserTable = (props: IUserTableProps) => {
	const { domainTableContainer, tableColumnTextColor, domainTable, scrollableTableContainer } = useOrganizationStyles();
	const { t } = useTranslation();

	return (
		<LiteBox className={scrollableTableContainer} mt={1} pl={2}>
			<table className={domainTable}>
				<thead>
					<tr>
						<th>
							<Typography
								className={tableColumnTextColor}
								style={{ paddingLeft: 18, fontSize: 14, fontWeight: 600 }}
								variant="subtitle1"
								align="left"
							>
								{t("Username")}
							</Typography>
						</th>
					</tr>
				</thead>
				<tbody className={domainTableContainer}>
					{props.users.map((user) => (
						<tr key={user.id}>
							<td>
								<Typography
									style={{ marginTop: 2, marginBottom: 2, paddingLeft: 18, fontSize: 14 }}
									variant="subtitle1"
								>{`${user.firstName} ${user.lastName}`}</Typography>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</LiteBox>
	);
};
